import {dateTimeStringFromApiToDate} from "../../../index";
import {KompetenceDatoKategoriEnum} from "./KompetenceDatoKategoriEnum";

export class DashboardBrugerKompetenceAktivitetModel {
    brugerId: string;
    sidsteAktivitetDato: Date;
    datoKategori: KompetenceDatoKategoriEnum;

    static Build(responseModel: DashboardBrugerKompetenceAktivitetResponseModel): DashboardBrugerKompetenceAktivitetModel {
        let model = new DashboardBrugerKompetenceAktivitetModel();
        model.brugerId = responseModel.brugerId;
        model.sidsteAktivitetDato = dateTimeStringFromApiToDate(responseModel.sidsteAktivitetDato);
        return model;
    }
}

export type DashboardBrugerKompetenceAktivitetResponseModel = {
    brugerId: string
    sidsteAktivitetDato: string
}
